import { render, staticRenderFns } from "./GameStatsMode.vue?vue&type=template&id=4a62bab5&scoped=true&"
import script from "./GameStatsMode.vue?vue&type=script&lang=js&"
export * from "./GameStatsMode.vue?vue&type=script&lang=js&"
import style0 from "./GameStatsMode.vue?vue&type=style&index=0&id=4a62bab5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a62bab5",
  null
  
)

export default component.exports